import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HelpSource } from '../../models/help-chat.models';

/**
 * Anchor-basierte Karte unter der Assistant-Bubble (Quellen).
 * Echte <a>-Elemente -> Screenreader erkennen sie als Links, Tab-Fokus
 * funktioniert. Klick wird vom Eltern-Komponenten zentral abgefangen.
 */
@Component({
  selector: 'app-help-source-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <a
      class="source-card"
      [attr.href]="targetHref"
      (click)="onClick($event)"
      [attr.aria-label]="'Quelle: ' + (source?.title || '')"
    >
      <span class="source-card__icon" aria-hidden="true">{{ source?.tourKey ? '▶' : '📄' }}</span>
      <span class="source-card__title">{{ source?.title }}</span>
      <span class="source-card__chev" aria-hidden="true">›</span>
    </a>
  `,
  styles: [
    `
      .source-card {
        display: flex;
        align-items: center;
        gap: 9px;
        padding: 8px 11px;
        margin-top: 6px;
        border: 1px solid var(--clr-border, #d0d4d8);
        border-radius: 9px;
        color: var(--clr-text-100, #1d2733);
        text-decoration: none;
        background: var(--clr-surface-100, #fff);
        cursor: pointer;
        transition: background 0.15s ease, border-color 0.15s ease;
      }
      .source-card:hover,
      .source-card:focus-visible {
        background: var(--clr-surface-200, #f4f5f8);
        border-color: var(--clr-primary-100, #4ccaf1);
        outline: 2px solid var(--clr-primary-100, #4ccaf1);
        outline-offset: 1px;
      }
      .source-card__icon {
        font-size: 12px;
        color: var(--clr-primary-200, #3e95be);
        flex-shrink: 0;
      }
      .source-card__title {
        flex: 1;
        font-weight: 600;
        font-size: 12.5px;
        line-height: 1.3;
      }
      .source-card__chev {
        color: var(--clr-text-300, #94a1ad);
        font-size: 15px;
        flex-shrink: 0;
      }
    `,
  ],
})
export class HelpSourceCardComponent {
  @Input() source: HelpSource | null = null;
  @Output() activate = new EventEmitter<HelpSource>();

  protected get targetHref(): string {
    if (this.source?.tourKey) {
      return `tour:${this.source.tourKey}`;
    }
    return `#source-${this.source?.slug ?? ''}`;
  }

  protected onClick(ev: MouseEvent): void {
    ev.preventDefault();
    if (this.source) {
      this.activate.emit(this.source);
    }
  }
}
